"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
var material_1 = require("@mui/material");
// import { Field, useField, useForm } from 'react-final-form';
var react_final_form_1 = require("react-final-form");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
// import LineButton from 'atomicComponents/atoms/Buttons/LineButton';
var hooks_1 = require("containers/Onboarding/hooks");
var StandardSelect_1 = __importDefault(require("shared/components/Form/Select/StandardSelect"));
var TextField_1 = __importDefault(require("shared/components/Form/TextField"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var validators_1 = require("utils/form/validators");
var hooks_2 = require("utils/hooks");
var logging_1 = require("utils/logging");
var ordered_1 = require("utils/selectors/ordered");
var single_1 = require("utils/selectors/single");
var InviteTemplate_1 = __importDefault(require("./InviteTemplate"));
var PREFIX = 'AddTeamMembers';
var classes = {
    email: "".concat(PREFIX, "-email"),
    import: "".concat(PREFIX, "-import"),
};
var StyledInviteTemplate = (0, material_1.styled)(InviteTemplate_1.default)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[".".concat(classes.email)] = {
            margin: theme.spacing(2, 0),
            display: 'block',
            '& .MuiInput-root': {
                width: '100%',
            },
        },
        _b[".".concat(classes.import)] = {
            padding: theme.spacing(0.5, 2),
            color: theme.palette.grey[700],
        },
        _b);
});
var AddUsers = function (_a) {
    var _b;
    var team = _a.team, setTeamId = _a.setTeamId;
    var history = (0, react_router_dom_1.useHistory)();
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var companyTeams = (0, react_redux_1.useSelector)(ordered_1.selectCompanyTeams);
    var addUserOnboardingStep = (0, hooks_1.useAddUserOnboardingStep)();
    var fieldError = false;
    var _c = (0, react_final_form_1.useField)('memberEmails', { subscription: { value: true, error: true } }), emails = _c.input.value, error = _c.meta.error;
    // const { getFieldState, blur, getRegisteredFields } = useForm();
    var _d = __read((0, hooks_2.useSubmitter)('invitations', null, { companyId: profile.companyId }), 1), invitationSubmitter = _d[0];
    var numberOfLines = Math.max(3, ((_b = emails === null || emails === void 0 ? void 0 : emails.filter(Boolean).length) !== null && _b !== void 0 ? _b : 0) + 1);
    var fieldErrors = error === null || error === void 0 ? void 0 : error.slice(0, -1).filter(Boolean);
    var currentEmails = emails.filter(Boolean);
    if (((currentEmails === null || currentEmails === void 0 ? void 0 : currentEmails.length) === 1 || (currentEmails === null || currentEmails === void 0 ? void 0 : currentEmails.length) === 0) && (fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.length) > 1) {
        fieldError = true;
    }
    else if ((currentEmails === null || currentEmails === void 0 ? void 0 : currentEmails.length) > 1 && (fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.length) >= 1) {
        fieldError = true;
    }
    // const uploadEmailsCSV = (e) => {
    //   const file = e.target.files[0];
    //   const reader = new FileReader();
    //   reader.readAsText(file);
    //   reader.onload = () => {
    //     const result = parse(reader.result as string).flat().slice(1);
    //     onChange([...emails, ...result]);
    //     getRegisteredFields().forEach((field) => {
    //       if (getFieldState(field)?.value) {
    //         blur(field);
    //       }
    //     });
    //   };
    // };
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, Promise.all(emails.filter(Boolean).map(function (email) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, invitationSubmitter({
                                            email: email,
                                            inviterId: profile.id,
                                            companyTeamId: team === null || team === void 0 ? void 0 : team.id,
                                            type: 'user',
                                            accessLevel: interfaces_1.ACCESS_LEVEL.User,
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 1:
                    _a.sent();
                    addUserOnboardingStep('INVITE_TEAMMATES');
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    (0, logging_1.logError)(e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(StyledInviteTemplate, __assign({ onBeforeClick: handleSubmit, isNextDisabled: fieldError, onPrevClick: function () { return history.goBack(); }, onClick: function () { return history.push('dashboard'); } }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "Invite team members" })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ mt: 1, mb: 2 }, { children: (0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1 }, { children: "Team members will have access to Hudled and can see all SaaS related spend." })) })), (0, jsx_runtime_1.jsx)(material_1.Box, { children: !!(companyTeams === null || companyTeams === void 0 ? void 0 : companyTeams.length) && ((0, jsx_runtime_1.jsx)(StandardSelect_1.default, { options: companyTeams.map(function (t) { return ({ label: t.name, value: t.id }); }), label: "Team", id: "team-name", value: team === null || team === void 0 ? void 0 : team.id, onChange: function (teamId) { return setTeamId(teamId); } })) }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", flexDirection: "column", mt: 4 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2 }, { children: "Input emails" })), __spreadArray([], __read(Array(numberOfLines).keys()), false).map(function (idx) { return ((0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "memberEmails[".concat(idx, "]"), component: TextField_1.default, className: classes.email, color: "secondary", label: "Email team member ".concat(idx + 1), validate: validators_1.getEmailError, sx: { mt: 2 } }, idx)); })] }))] })));
};
exports.default = AddUsers;
